import { useMutation, useQueryClient } from '@tanstack/react-query';
import { grantUserPermission } from '../services/userRbac';
import { userKeys } from './useUsersQuery';
import { handleUserMutationError } from '../services/userErrorHandler';

interface GrantPermissionParams {
    userId: string;
    permissionId: string;
}

export const useGrantPermissionMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, GrantPermissionParams>({
        mutationFn: ({ userId, permissionId }) => grantUserPermission(userId, permissionId),
        onSuccess: (_, { userId }) => {
            queryClient.invalidateQueries({ queryKey: userKeys.permissions(userId) });
            queryClient.invalidateQueries({ queryKey: userKeys.detail(userId) });
        },
        onError: (error) => handleUserMutationError(error),
    });
};
